module.exports = __webpack_public_path__ + "media/styles/images/svg/annotation-gray-966e066169a9a0d501c299dba157f4f2.svg";